import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { SaveDataObj } from "../../framework/saveData";
import { customHistory } from "../../framework/customHistory";
import { RouteComponentProps } from "react-router";
import * as storeTypes from "../../models/store/storeTypes";
import * as userFurtherEducationService from "../../models/services/userFurtherEducationService";
import { Translations } from "ui/Scripts/source/models/translations";
import { EditPageHeader } from "../app/header";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { ConfirmationDialogResult, EnumHelper, RecordEducationScopeUnit, RecordUserAttachmentCategory } from "ui/Scripts/source/models/enums";
import { IUserFurtherEducationEditItem, UserFurtherEducationEditItem } from "../../models/userFurtherEducation/userFurtherEducationEditItem";
import { DatePicker } from "../framework/datePicker";
import { CheckBox } from "ui/Scripts/source/components/framework/checkbox";
import { AppUtils } from "../../framework/appUtils";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { RecordEditAttachmentList } from "../record/recordEditAttachmentList";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { SelectIdTitleNodeDialog } from "../framework/selectIdTitleNodeDialog";
import { IRecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";
import { Footer } from "../app/footer";
import { IRecordFurtherEducationGroupNode, RecordFurtherEducationGroupNode } from "ui/Scripts/source/models/recordFurtherEducationGroup/recordFurtherEducationGroupNode";
import { IRecordFurtherEducationNode } from "ui/Scripts/source/models/recordFurtherEducation/recordFurtherEducationNode";

export interface IUserFurtherEducationEditOwnProps {
}

export interface IUserFurtherEducationEditStateProps {
    item: IUserFurtherEducationEditItem;
    attachments: IFileAttachment[];
    furtherEducationGroups: IRecordFurtherEducationGroupNode[]
    qualifications: IRecordListItemUserQualification[];
    returnUrl: string;
}

export interface IUserFurtherEducationEditDispatchProps {
    loadUserFurtherEducation: (id: string) => void;
    resetUserFurtherEducation: () => void;
}

export interface IUserFurtherEducationEditPathProps {
    userFurtherEducationId: string;
}

type UserFurtherEducationEditViewProp = IUserFurtherEducationEditOwnProps & IUserFurtherEducationEditStateProps & IUserFurtherEducationEditDispatchProps & RouteComponentProps<IUserFurtherEducationEditPathProps>;

/* eslint-disable no-unused-vars */
const enum NewUserFurtherEducationWizardWindowType {
    FurtherEducation = "0"
}
/* eslint-enable no-unused-vars */

interface IUserFurtherEducationEditViewState {
    furtherEducations: IIdTitleNode[];
    scopeUnits: RecordEducationScopeUnit[];
    isNew: boolean;
    id: string;
    rowId: string;
    furtherEducationId: string;
    scope: string;
    scopeReadOnly: boolean;
    scopeUnit: number;
    startDate: string;
    endDate: string;
    validityEndDate: string;
    validity: number;
    comment: string;
    activeState: number;
    //Attachments
    cameraVisible: boolean;
    attachments: IFileAttachment[];
    //Calculated fields
    furtherEducationCode: string;
    //Dialogs
    newUserFurtherEducationWizardWindows: NewUserFurtherEducationWizardWindowType[];
    newUserFurtherEducationWizardWindowIndex: number;
    showSelectFurtherEducationDialog: boolean;
}
    
interface INewUserFurtherEducationWizardWindows {
    windows: NewUserFurtherEducationWizardWindowType[];
    index: number;
}

export class UserFurtherEducationEditView extends React.Component<UserFurtherEducationEditViewProp, IUserFurtherEducationEditViewState> {
    private static orgStateHash = "";
    private static hashIgnoreSaveDataFields = ["id", "rowId"];

    private dataContainerDiv: HTMLDivElement;
    private scrollToTop: boolean;
    private scrollToClassName: string;
     
    private static setFurtherEducationTitle = (furtherEducations: IIdTitleNode[], qualifications: IRecordListItemUserQualification[]) => {
        for (const furtherEducation of furtherEducations) {
            const isQualification = qualifications.findIndex(i => i.furtherEducationId === furtherEducation.id) > -1;
            if (isQualification) {
                furtherEducation.title = furtherEducation.title + " (" + Translations.Qualification + ")";
            }
            UserFurtherEducationEditView.setFurtherEducationTitle(furtherEducation.children, qualifications);
        }
    };

    private static getFurtherEducations = (furtherEducationGroups: IRecordFurtherEducationGroupNode[], qualifications: IRecordListItemUserQualification[]): IIdTitleNode[] => {
        if (!furtherEducationGroups || furtherEducationGroups.length < 1) return [];
        const furtherEducations = RecordFurtherEducationGroupNode.getFurtherEducations(furtherEducationGroups);
        if (!qualifications || qualifications.length < 1) return furtherEducations;
        const result = furtherEducations.map(i => new IdTitleNode(i));
        UserFurtherEducationEditView.setFurtherEducationTitle(result, qualifications);
        return result;
    };

    private static getValidScopeUnits = (furtherEducation: IRecordFurtherEducationNode): RecordEducationScopeUnit[] => {
        let result: RecordEducationScopeUnit[] = [
            RecordEducationScopeUnit.Hour,
            RecordEducationScopeUnit.Day,
            RecordEducationScopeUnit.CourseCredit,
            RecordEducationScopeUnit.StudyWeek,
            RecordEducationScopeUnit.Course
        ];
        if (furtherEducation) {
            if (furtherEducation.scopeUnit !== 99) {
                result = [furtherEducation.scopeUnit as RecordEducationScopeUnit];
            }
        }
        return result;
    };

    private static getSaveDataFromState = (props: UserFurtherEducationEditViewProp, state: IUserFurtherEducationEditViewState): SaveDataObj => {
        const data = new SaveDataObj();
        data.append("id", props.item.id);
        data.append("rowId", state.rowId);
        data.append("furtherEducationId", state.furtherEducationId);
        data.append("scope", state.scope.toInteger());
        data.append("scopeUnit", state.scopeUnit);
        data.append("startDate", state.startDate.toUtcDate().getTime());
        data.append("endDate", state.endDate ? state.endDate.toUtcDate().getTime() : null);
        data.append("validityEndDate", state.validityEndDate ? state.validityEndDate.toUtcDate().getTime() : null);
        data.append("comment", state.comment);
        data.append("activeState", state.activeState);
        return data;
    };

    private static getNewUserFurtherEducationWizardWindows(props: UserFurtherEducationEditViewProp): INewUserFurtherEducationWizardWindows {
        const result: INewUserFurtherEducationWizardWindows = {
            windows: [],
            index: -1
        };
        const isNew = props.match.params.userFurtherEducationId === Base.emptyGuid;
        if (!isNew) return result;
        if (RecordFurtherEducationGroupNode.getRecordFurtherEducationCount(props.furtherEducationGroups) > 1) {
            result.windows.push(NewUserFurtherEducationWizardWindowType.FurtherEducation);
        }
        if (result.windows.length > 0) {
            result.index = 0;
        }
        return result;
    }

    private static getStateFromProps = (props: UserFurtherEducationEditViewProp): IUserFurtherEducationEditViewState => {
        const isNew = props.match.params.userFurtherEducationId === Base.emptyGuid;
        let item = props.item;
        if (!item) {
            item = new UserFurtherEducationEditItem();
        }
        const newUserFurtherEducationWizardWindows = UserFurtherEducationEditView.getNewUserFurtherEducationWizardWindows(props);
        const furtherEducations = UserFurtherEducationEditView.getFurtherEducations(props.furtherEducationGroups, props.qualifications);
        const furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(props.furtherEducationGroups, item.furtherEducationId);
        const scopeUnits = UserFurtherEducationEditView.getValidScopeUnits(furtherEducation);
        if (scopeUnits.length < 2) {
            if (scopeUnits[0] !== item.scopeUnit) {
                scopeUnits.push(item.scopeUnit);
            }
        }
        const startDate = Base.utcTimeToDateStr(item.startDate);
        const scope = furtherEducation?.scope ?? 0;
        const validity = furtherEducation?.validity ?? 0;
        const scopeReadOnly = scope > 0;
        const result: IUserFurtherEducationEditViewState = {
            furtherEducations,
            scopeUnits,
            isNew,
            id: item.id,
            rowId: item.rowId,
            furtherEducationId: item.furtherEducationId,
            scope: (isNew && scopeReadOnly
                ? scope
                : item.scope).toString(10),
            scopeReadOnly,
            scopeUnit: item.scopeUnit,
            startDate,
            endDate: Base.utcTimeToDateStr(item.endDate),
            validityEndDate: Base.utcTimeToDateStr(isNew && item.startDate && validity > 0
                ? startDate.toUtcDate().addYears(validity).getTime()
                : item.validityEndDate),
            validity,
            comment: item.comment,
            activeState: item.activeState,
            //Attachments
            cameraVisible: false,
            attachments: props.attachments.slice(0),
            //Calculated fields
            furtherEducationCode: RecordFurtherEducationGroupNode.getRecordFurtherEducationById(props.furtherEducationGroups, item.furtherEducationId)?.code ?? "",
            //Dialogs
            newUserFurtherEducationWizardWindows: newUserFurtherEducationWizardWindows.windows.slice(0),
            newUserFurtherEducationWizardWindowIndex: newUserFurtherEducationWizardWindows.index,
            showSelectFurtherEducationDialog: false
        };
        if (item.id) {
            const saveData = UserFurtherEducationEditView.getSaveDataFromState(props, result);
            UserFurtherEducationEditView.orgStateHash = saveData.getHash(UserFurtherEducationEditView.hashIgnoreSaveDataFields);
        } else {
            UserFurtherEducationEditView.orgStateHash = "";
        }
        return result;
    };

    constructor(props: UserFurtherEducationEditViewProp) {
        super(props);
        this.scrollToTop = false;
        this.scrollToClassName = null;
        this.state = UserFurtherEducationEditView.getStateFromProps(props);
    }

    static getDerivedStateFromProps(nextProps: UserFurtherEducationEditViewProp, prevState: IUserFurtherEducationEditViewState): IUserFurtherEducationEditViewState {
        if (!prevState.id || (!!nextProps.item && nextProps.item.id !== prevState.id)) {
            return UserFurtherEducationEditView.getStateFromProps(nextProps);
        } else {
            return null;
        }
    }

    private scrollToRowElement = () => {
        if (!Base.isNullOrEmpty(this.scrollToClassName)) {
            if (this.dataContainerDiv.scrollTo !== null && this.dataContainerDiv.scrollTo !== undefined) {
                const elements = this.dataContainerDiv.getElementsByClassName(this.scrollToClassName);
                if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
                    const y = (elements[0] as HTMLDivElement).offsetTop;
                    this.dataContainerDiv.scrollTo({
                        top: y,
                        left: 0,
                        behavior: "auto"
                    });
                }
            }
            this.scrollToClassName = null;
        }
    };

    componentDidMount(): void {
        this.props.loadUserFurtherEducation(this.props.match.params.userFurtherEducationId);
    }

    componentDidUpdate(prevProps: UserFurtherEducationEditViewProp, prevState: IUserFurtherEducationEditViewState): void {
        if (this.scrollToTop) {
            if (!this.dataContainerDiv.scrollTo) {
                this.dataContainerDiv.scrollTop = 0;
                this.dataContainerDiv.scrollLeft = 0;
            } else {
                this.dataContainerDiv.scrollTo(0, 0);
            }
            this.scrollToTop = false;
        } else {
            //Scroll to attachments after closing camera
            this.scrollToRowElement();
        }
    }

    componentWillUnmount(): void {
        this.props.resetUserFurtherEducation();
    }

    //#region New User Further Education Wizard
    setFurtherEducation = (id: string, newUserFurtherEducationWizardWindowIndex: number, showSelectFurtherEducationDialog: boolean) => {
        if (!id) return;
        const furtherEducation = RecordFurtherEducationGroupNode.getRecordFurtherEducationById(this.props.furtherEducationGroups, id);
        if (!furtherEducation) return;
        const state = this.state;
        const scopeUnits = UserFurtherEducationEditView.getValidScopeUnits(furtherEducation);
        const scopeReadOnly = furtherEducation.scope > 0;
        const validity = furtherEducation.validity;
        this.setState({
            newUserFurtherEducationWizardWindowIndex,
            showSelectFurtherEducationDialog,
            furtherEducationId: id,
            furtherEducationCode: furtherEducation.code,
            scopeUnits,
            scopeUnit: scopeUnits.length < 2
                ? scopeUnits[0]
                : state.scopeUnit,
            scope: scopeReadOnly
                ? furtherEducation.scope.toString(10)
                : state.scope,
            scopeReadOnly,
            validityEndDate: validity > 0 && state.startDate
                ? Base.utcTimeToDateStr(state.startDate.toUtcDate().addYears(furtherEducation.validity).getTime())
                : state.validityEndDate,
            validity
        });
    };

    handleNewUserFurtherEducationWizardDialogNext = (id: string) => {
        const state = this.state;
        this.setFurtherEducation(id, state.newUserFurtherEducationWizardWindowIndex + 1 < state.newUserFurtherEducationWizardWindows.length ? state.newUserFurtherEducationWizardWindowIndex + 1 : -1, state.showSelectFurtherEducationDialog);
    };

    handleNewUserFurtherEducationWizardDialogPrevious = () => {
        const state = this.state;
        this.setState({
            newUserFurtherEducationWizardWindowIndex: state.newUserFurtherEducationWizardWindowIndex - 1
        });
    };

    handleNewUserFurtherEducationWizardDialogCancel = () => {
        this.setState({
            newUserFurtherEducationWizardWindowIndex: -1
        });
    };
    //#endregion New Task Wizard

    //#region FurtherEducation
    handleChangeFurtherEducationClick = () => {
        this.setState({
            showSelectFurtherEducationDialog: true,
        });
    };

    handleSelectFurtherEducationDialogOk = (id: string) => {
        const state = this.state;
        this.setFurtherEducation(id, state.newUserFurtherEducationWizardWindowIndex, false);
    };

    handleSelectFurtherEducationDialogCancel = () => {
        this.setState({
            showSelectFurtherEducationDialog: false
        });
    };
    //#endregion FurtherEducation

    //#region General
    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "scope") {
            this.setState({ scope: value });
        } if (name === "scopeUnit") {
            this.setState({ scopeUnit: value.toInteger() });
        } if (name === "comment") {
            this.setState({ comment: value });
        }
    };

    handleBlur = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "scope") {
            this.setState({ scope: value.toInteger().toString(10) });
        }
    };

    dateChange = (startDate: Date, endDate: Date) => {
        if (!Base.isNullOrUndefined(startDate) && !Base.isNullOrUndefined(endDate) && endDate < startDate) {
            endDate = startDate;
        }
        const startDateStr = Base.utcTimeToDateStr(startDate.getTime());
        const endDateStr = endDate ? Base.utcTimeToDateStr(endDate.getTime()) : "";
        const state = this.state;
        this.setState({
            startDate: startDateStr,
            endDate: endDateStr,
            validityEndDate: state.validity > 0 && startDateStr
                ? Base.utcTimeToDateStr(startDateStr.toUtcDate().addYears(state.validity).getTime())
                : state.validityEndDate
        });
    };

    handleStartDateChange = (value: string) => {
        this.setState({ startDate: value });
    };

    handleStartDateBlur = (value: string) => {
        const state = this.state;
        this.dateChange(value ? value.toUtcDate() : Base.getNowUtcDate().addDays(-1), state.endDate ? state.endDate.toUtcDate() : null);
    };

    handleEndDateChange = (value: string) => {
        this.setState({ endDate: value });
    };

    handleEndDateBlur = (value: string) => {
        const state = this.state;
        this.dateChange(state.startDate ? state.startDate.toUtcDate() : Base.getNowUtcDate().addDays(-1), value ? value.toUtcDate() : null);
    };

    handleValidityEndDateChange = (value: string) => {
        this.setState({ validityEndDate: value });
    };

    handleValidityEndDateBlur = (value: string) => {
        this.setState({
            validityEndDate: value ? Base.utcTimeToDateStr(value.toUtcDate().getTime()) : ""
        });
    };
    //#endregion General

    // #region Attachments
    handleAttachmentsRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            attachments: this.state.attachments.filter(i => ids.indexOf(i.id) < 0),
        });
    };

    handleAttachmentsAdded = (attachments: IFileAttachment[]) => {
        if (!attachments || attachments.length < 1) return;
        const newAttachments = this.state.attachments.concat(attachments);
        FileAttachment.sortFileAttachments(newAttachments);
        this.setState({
            attachments: newAttachments
        });
    };
    // #endregion Attachments

    checkErrors = (): Promise<boolean> => {
        const state = this.state;
        return new Promise<boolean>((resolve) => {
            if (state.endDate) {
                const endDate = state.endDate.toUtcDate().getTime();
                const startDate = state.startDate.toUtcDate().getTime();
                if (endDate < startDate) {
                    AppUtils.showErrorMessage(Translations.TrainingEndDateCannotPrecedeTrainingStartDate);
                    return resolve(false);
                }
            }
            return resolve(true);
        });
    };

    getWarningMessage = (): Promise<string> => {
        return new Promise<string>((resolve) => {
            return resolve("");
        });
    };
    
    closeView = (): void => {
        const props = this.props;
        const returnUrl = !Base.isNullOrEmpty(props.returnUrl) ? props.returnUrl : "/userfurthereducation";
        customHistory.push(returnUrl);
    };

    saveUserFurtherEducation = async () => {
        const state = this.state;
        const props = this.props;
        if (!await AppUtils.validate(this.checkErrors, this.getWarningMessage)) return null;
        const saveData = UserFurtherEducationEditView.getSaveDataFromState(props, state);
        // Call server
        const result = await AppUtils.callService(() => userFurtherEducationService.saveUserFurtherEducation(saveData.obj));
        if (!result) return null;
        this.closeView();
    };

    handleSaveClick = async () => {
        const result = await AppUtils.showConfirmationDialog(Translations.SaveUserFurtherEducationConfirmation, false, storeTypes.ConfirmationDialogType.Information, Translations.SaveUserFurtherEducation);
        if (result === ConfirmationDialogResult.Yes) {
            this.saveUserFurtherEducation();
        }
    };

    handleBackClick = async () => {
        const cancelResult = await AppUtils.cancel(UserFurtherEducationEditView.getSaveDataFromState(this.props, this.state).getHash(UserFurtherEducationEditView.hashIgnoreSaveDataFields), UserFurtherEducationEditView.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveUserFurtherEducation();
        } else {
            this.closeView();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        const item = props.item;
        if (item == null) {
            return (
                <div className="pageBackground" style={ { zIndex: 2 } }>
                    <EditPageHeader
                        title={Translations.FurtherEducation}
                        onBackClick={this.handleBackClick}
                    />
                </div>
            );
        }
        return (
            <div className="pageBackground" style={ { zIndex: 2 } }>
                {!state.cameraVisible &&
                    <React.Fragment>
                        <EditPageHeader
                            title={Translations.FurtherEducation}
                            onBackClick={this.handleBackClick}
                        />
                        <Footer
                            onClick={this.handleSaveClick}
                        />
                    </React.Fragment>
                }
                <div className="pageContentContainer mainEdit userFurtherEducationEdit">
                    <div className="dataContainer" ref={(elem) => { this.dataContainerDiv = elem; }}>
                        {!state.cameraVisible &&
                            <div>
                                <div className="sectionTitle">{Translations.FurtherEducation + " - " + (state.isNew ? Translations.ANew : state.furtherEducationCode.substr(0, 25))}</div>
                                {RecordFurtherEducationGroupNode.getRecordFurtherEducationCount(props.furtherEducationGroups) < 2
                                    ? (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="control-label">{Translations.Subject}</label>
                                                    <div>{state.furtherEducationCode}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <div>
                                                        <label className="control-label">{Translations.Subject}</label>
                                                        <ToolButton
                                                            tooltip={Translations.Change}
                                                            classes={"edit round mono smaller right"}
                                                            onClick={this.handleChangeFurtherEducationClick}
                                                        />
                                                    </div>
                                                    <div>{state.furtherEducationCode}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group required">
                                            <label className="control-label">{Translations.Scope}</label>
                                            <input className="form-control" type="text" name="scope" title={Translations.Scope} maxLength={8} value={state.scope} required={true} disabled={state.scopeReadOnly} readOnly={state.scopeReadOnly} onChange={this.handleChange} onBlur={this.handleBlur} />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.ScopeUnit}</label>
                                            <select className="form-control" name="scopeUnit" title={Translations.ScopeUnit} value={state.scopeUnit.toString(10)} onChange={this.handleChange} disabled={state.scopeUnits.length < 2}>
                                                {state.scopeUnits.map(scopeUnit =>
                                                    <option key={scopeUnit} value={scopeUnit.toString(10)}>{EnumHelper.RecordEducationScopeUnitToStr(scopeUnit)}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group required">
                                            <DatePicker
                                                required={true}
                                                title={Translations.TrainingStartDate}
                                                value={state.startDate}
                                                onChange={this.handleStartDateChange}
                                                onBlur={this.handleStartDateBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <DatePicker
                                                required={false}
                                                openRight={true}
                                                title={Translations.TrainingEndDate}
                                                value={state.endDate}
                                                onChange={this.handleEndDateChange}
                                                onBlur={this.handleEndDateBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <DatePicker
                                                required={false}
                                                title={Translations.ValidityEndDate}
                                                value={state.validityEndDate}
                                                onChange={this.handleValidityEndDateChange}
                                                onBlur={this.handleValidityEndDateBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="control-label">{Translations.AdditionalInformation}</label>
                                            <textarea className="form-control large" name="comment" title={Translations.AdditionalInformation} maxLength={1000} readOnly={false} disabled={false} value={state.comment} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group pt-1">
                                            <CheckBox
                                                classes={"large"}
                                                checked={state.activeState < 0.5}
                                                title={Translations.Archived}
                                                onClickBoolean={(checked: boolean) => this.setState({ activeState: checked ? 0 : 1 })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <RecordEditAttachmentList
                            isReadOnly={state.isNew}
                            companyId={Base.emptyGuid}
                            recordId={Base.emptyGuid}
                            subOwnerId={state.id}
                            userCode=""
                            category={RecordUserAttachmentCategory.FurtherEducation}
                            attachments={state.attachments}
                            onShowCamera={value => this.setState({ cameraVisible: value })}
                            onRemoved={this.handleAttachmentsRemoved}
                            onAdded={this.handleAttachmentsAdded}
                        />
                    </div>
                </div>
                {state.newUserFurtherEducationWizardWindowIndex > -0.5 && state.newUserFurtherEducationWizardWindows[state.newUserFurtherEducationWizardWindowIndex] === NewUserFurtherEducationWizardWindowType.FurtherEducation &&
                    <SelectIdTitleNodeDialog
                        nextPreviousMode={true}
                        title={Translations.SelectSubject}
                        selectedId={state.furtherEducationId}
                        values={state.furtherEducations}
                        onOk={this.handleNewUserFurtherEducationWizardDialogNext}
                        onCancel={this.handleNewUserFurtherEducationWizardDialogCancel}
                        onPrevious={state.newUserFurtherEducationWizardWindowIndex > 0 ? this.handleNewUserFurtherEducationWizardDialogPrevious : null}
                    />
                }
                {state.showSelectFurtherEducationDialog &&
                    <SelectIdTitleNodeDialog
                        title={Translations.SelectSubject}
                        selectedId={state.furtherEducationId}
                        values={state.furtherEducations}
                        onOk={this.handleSelectFurtherEducationDialogOk}
                        onCancel={this.handleSelectFurtherEducationDialogCancel}
                    />
                }
            </div>
        );
    }
}